import gql from 'graphql-tag';

const query = gql`
  query OptimalBloodSugarTarget {
    diabetes {
      userDiabetes {
        treatment {
          optimalBloodSugarTarget {
            min {
              value
              unit
            }
            max {
              value
              unit
            }
          }
        }
      }
    }
  }
`;

export default query;
